import Icon from '@/components/ui/AppIcon';

const SavedSessions = () => {
  const sessions = [
    {
      id: 'session_1',
      title: 'Navigation Study Session',
      progress: 45,
      questionsCompleted: 23,
      totalQuestions: 50,
      timeRemaining: '42:15',
      lastAccessed: '2 hours ago',
    },
    {
      id: 'session_2',
      title: 'Regulations Test Mode',
      progress: 68,
      questionsCompleted: 34,
      totalQuestions: 50,
      timeRemaining: '28:30',
      lastAccessed: '1 day ago',
    },
    {
      id: 'session_3',
      title: 'Aircraft Systems Review',
      progress: 12,
      questionsCompleted: 9,
      totalQuestions: 75,
      timeRemaining: '1:15:00',
      lastAccessed: '3 days ago',
    },
  ]

  return (
    <section className="bg-card rounded-2xl p-6 md:p-8 border border-border">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-bold text-foreground mb-1">Saved Sessions</h2>
          <p className="text-sm text-muted-foreground">Resume your incomplete tests</p>
        </div>
        <Icon name="BookmarkIcon" size={24} className="text-muted-foreground" />
      </div>
      <div className="space-y-4">
        {sessions?.map((session) => (
          <div key={session?.id} className="p-4 bg-background rounded-xl border border-border hover:border-primary/50 transition-colors">
            <div className="flex items-start justify-between mb-3">
              <div className="flex-1">
                <h3 className="font-semibold text-foreground mb-1">{session?.title}</h3>
                <p className="text-sm text-muted-foreground">
                  {session?.questionsCompleted} of {session?.totalQuestions} questions • {session?.timeRemaining} remaining
                </p>
              </div>
              <button className="px-4 py-2 bg-primary text-primary-foreground font-semibold rounded-lg hover:bg-primary/90 transition-colors text-sm">
                Resume
              </button>
            </div>
            <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
              <div
                className="h-full bg-primary transition-all"
                style={{ width: `${session?.progress}%` }}
              />
            </div>
            <div className="flex items-center justify-between mt-2">
              <span className="text-xs text-muted-foreground">{session?.progress}% complete</span>
              <span className="text-xs text-muted-foreground">Last accessed {session?.lastAccessed}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default SavedSessions